import axios from "axios";
import store from "../store";
const qs = require("qs");
import { getUserID, getToken, getRefreshToken, setToken, setAccessToken, getLoginType } from "./tokenCheck";

const trainingServe = axios.create({
	// baseURL: "http://127.0.0.1:8003/",
	// baseURL:"https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/assessment/",
	// baseURL: "https://training-api.simplifycv.com/", // development
	// "https://training-api.simplifymycareer.com/", // staging
	baseURL:
		// "https://training-api.simplifycv.com/", // development
		"https://gateway.hire3x.com/training/", // prod
});

const request = axios.create({
	// "https://training-api.simplifymycareer.com/" // staging
	// "https://training-api.hire3x.com/" // production
	// baseURL: "http://127.0.0.1:8000/",
	baseURL:
		// "https://training-api.simplifycv.com/", // development
		// "https://training-api.simplifymycareer.com/", // staging
		"https://gateway.hire3x.com/training/", // production
});

const requestUrl = axios.create({
	// baseURL: "http://127.0.0.1:8000/",
	// baseURL: "http://127.0.0.1:8000/",
	baseURL:
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/recruitment/", // Dev Gateway
		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/recruitment/", // Staging gateway
		"https://gateway.hire3x.com/recruitment/", // Production gateway
	// "http://10.10.12.97:8000/", // Local Server
});
const staticImageUrl = axios.create({
	// baseURL: "http://127.0.0.1:8000/",
	// baseURL: "http://127.0.0.1:8000/",
	baseURL:
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/candidate/", // Dev Gateway
		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/candidate/", // Staging gateway
		"https://gateway.hire3x.com/candidate/", // Production gateway
	// "http://10.10.12.97:8000/", // Local Server
});

const assessmentUrl = axios.create({
	// baseURL:"https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/assessment/", // Dev gateway
	// baseURL:"https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/assessment/", // staging Gateway
	baseURL: "https://gateway.hire3x.com/assessment/", // production Gateway
});

const SSOService = axios.create({
	baseURL:
		// "http://sso.simplifycv.com/", // Development
		// "https://auth.simplifymycareer.com/", // Staging & Development
		"https://auth.hire3x.com/", // Production
});
const uploadService = axios.create({
	// baseURL: "https://awsmultipart.simplifycv.com/", // Development
	// baseURL: "https://awsmultipart.simplifymycareer.com/", // Staging
	baseURL: "https://awsmultipart.hire3x.com/", // Production
	// "http://localhost:3000/",
});
const aiService = axios.create({
	baseURL: "https://resumeparser.hire3x.com/",
	// "http://localhost:3000/",
});

const requestrbac = axios.create({
	baseURL:
		// "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/rbac", //development
		// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/rbac", // Staging Gateway
		"https://gateway.hire3x.com/rbac/", // Production gateway
});

const deleteServe = axios.create({
	baseURL: "https://awsmultipart.hire3x.com/file", //development
	// "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/rbac" // Staging Gateway
	// "https://gateway.hire3x.com/rbac/", // Production gateway
});
const KeycloakAPIs = axios.create({
	// baseURL: "https://keynode.simplifycv.com/", // Development
	// baseURL: "https://keynode.simplifymycareer.com/", // Staging
	baseURL: "https://keynode.hire3x.com/", // Production
});
KeycloakAPIs.interceptors.request.use(
	(config) => {
		// config.headers["Authorization"] = "Bearer " + getToken();
		config.headers["userID"] = getUserID();
		return config;
	},
	(error) => {
		return error;
	}
);

const payment = axios.create({
	// baseURL: "https://payment.simplifycv.com/",
	// baseURL: "https://payment.simplifymycareer.com/",
	baseURL: "https://payment.hire3x.com/",
});
trainingServe.interceptors.request.use(
	(config) => {
		// config.headers["userID"] = getUserID();
		config.headers["Authorization"] = "Bearer " + getToken();
		return config;
	},
	(error) => {
		Promise.reject(error);
	}
);

trainingServe.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

request.interceptors.request.use(
	(config) => {
		// config.headers["userID"] = getUserID();
		config.headers["Authorization"] = "Bearer " + getToken();

		return config;
	},
	(error) => {
		return error;
	}
);

request.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

requestrbac.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();
		return config;
	},
	(error) => {
		return error;
	}
);

requestrbac.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

requestUrl.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();
		return config;
	},
	(error) => {
		return error;
	}
);

requestUrl.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

staticImageUrl.interceptors.request.use(
	(config) => {
		config.headers["Authorization"] = "Bearer " + getToken();
		return config;
	},
	(error) => {
		return error;
	}
);

staticImageUrl.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

uploadService.interceptors.request.use(
	(config) => {
		config.headers["userID"] = getUserID();
		return config;
	},
	(error) => {
		return error.response;
	}
);

deleteServe.interceptors.request.use(
	(config) => {
		config.headers["userID"] = getUserID();
		return config;
	},
	(error) => {
		return error.response;
	}
);

uploadService.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

payment.interceptors.request.use(
	(config) => {
		config.headers["userID"] = getUserID();

		return config;
	},
	(error) => {
		return error;
	}
);

payment.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);
aiService.interceptors.request.use(
	(config) => {
		config.headers["userID"] = getUserID();

		return config;
	},
	(error) => {
		return error;
	}
);

aiService.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		// Handle error
		if (
			error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401
		) {
			await refreshAccessToken();
			error.config.headers["Authorization"] = "bearer " + getToken();
			return axios(error.config);
		} else {
			return error.response;
		}
	}
);

// Getting new Access token using Refresh token
const getNewAccessToken = async () => {
	let payload = qs.stringify({
		grant_type: "refresh_token",
		client_id: "vue-test-app",
		refresh_token: getRefreshToken(),
	});

	try {
		const response = await axios({
			method: "post",
			url:
				// "https://auth.simplifymycareer.com/auth/realms/hire3x-dev/protocol/openid-connect/token", // Dev
				// "https://auth.simplifymycareer.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Staging
				"https://auth.hire3x.com/auth/realms/SimplifyCV/protocol/openid-connect/token", // Prod
			data: payload,
			headers: {
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
			},
		});

		setToken(response.data.access_token, response.data.refresh_token);
		if (response.status == 400) {
			localStorage.clear();
			store.dispatch("userVUEX/LogOut");
		}
	} catch (error) {
		localStorage.clear();
		store.dispatch("userVUEX/LogOut");
	}
};

// Unified function to refresh access token based on login type
export const refreshAccessToken = async () => {
	const loginData = getLoginType();
	if (loginData && loginData.logged_in === "google") {
		// User logged in via Google - use Google refresh endpoint
		await refreshGoogleToken();
	} else {
		// User logged in via Keycloak - use existing refresh flow
		await getNewAccessToken();
	}
};

// Refresh Google access token using the backend endpoint
export const refreshGoogleToken = async () => {
	const refreshToken = getRefreshToken();

	try {
		const response = await staticImageUrl.post("/can/auth/google-refresh/", {
			refresh_token: refreshToken
		});
		
		if (response.data.type === "Success") {
			const tokens = response.data.data;
			setAccessToken(tokens.id_token);
			// Note: Google doesn't return a new refresh_token on refresh, so we keep the existing one
		} else {
			localStorage.clear();
			store.dispatch("userVUEX/LogOut");
		}
	} catch (error) {
		if (axios.isCancel(error) || ["ECONNABORTED", "ERR_CANCELED"].includes(error.code)) {
			return;
		}
		localStorage.clear();
			store.dispatch("userVUEX/LogOut");
	}
};

assessmentUrl.interceptors.request.use(
	(config) => {
		// config.headers["u"] = getUserID();
		config.headers["Authorization"] = "Bearer " + getToken();

		return config;
	},
	(error) => {
		return error;
	}
);

assessmentUrl.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		return error.response;
	}
);
export {
	KeycloakAPIs,
	request,
	SSOService,
	requestrbac,
	uploadService,
	trainingServe,
	deleteServe,
	requestUrl,
	payment,
	staticImageUrl,
	aiService,
	getNewAccessToken,
	assessmentUrl,
};
